module.exports = __webpack_public_path__ + "static/fonts/Fact-Expanded.4def7ce.ttf";